// import { Stack, Typography } from "@mui/material";
// import { useProfile } from "app/contexts/profile";
// import { MdLock } from "react-icons/md";
import { Outlet } from "react-router-dom";

export function RoleGuard({ children, component, element, roles }) {
  // const profile = useProfile();

  // if (!roles) {
  //   throw new Error("roles is required");
  // }

  // if (!Array.isArray(roles)) {
  //   throw new Error("roles should be an array");
  // }

  // if (!roles.length) {
  //   throw new Error("roles shouldn't be empty");
  // }

  // const isStringArray = roles.every((role) => typeof role === "string");

  // if (!isStringArray) {
  //   throw new Error("roles should be an string array");
  // }

  // const isAllowed = roles.every((role) => profile.hasAccessTo(role));

  // if (!isAllowed) {
  //   return (
  //     <Stack
  //       justifyContent="center"
  //       alignItems="center"
  //       className="animate__animated animate__headShake"
  //       spacing={1}
  //       padding={4}
  //     >
  //       <Typography variant="h4" color="text.secondary">
  //         <Stack spacing={1} direction="row" alignItems="center">
  //           <MdLock />

  //           <span>Acceso restringido</span>
  //         </Stack>
  //       </Typography>

  //       <Typography variant="body2" color="text.secondary">
  //         Por favor, contáctese con el administrador del sistema.
  //       </Typography>
  //     </Stack>
  //   );
  // }

  return children || component || element || <Outlet />;
}
